import React, {Component} from 'react'
import PropTypes from "prop-types";
import SvGraphics from "../../assets/SvGraphics";
import Files from "react-files";


class LeumitSelfUpdateFileResponsiveComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isUploadingMultipleFile: false,
            entry: this.props.entry,
        }
    }

    async componentDidMount() {

    }


    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.entry !== prevProps.entry) {
            this.setState({
                entry: this.props.entry
            })
        }
    }

    loaderSwitch = () =>{
        this.setState({isUploadingMultipleFile:!this.state.isUploadingMultipleFile})
    }

    deleteUploadedFile = async (fileIndex,fileName) => {
        this.loaderSwitch()
        await this.props.deleteLeumitUploadedFile(this.props.index,fileIndex,fileName)
        this.loaderSwitch()
    }

    onFilesChange= async (selectedFile) => {
        this.loaderSwitch()
        await this.props.saveSelectedFile(selectedFile, this.props.index)
        this.loaderSwitch()
    }


    onClick = (e) => {
        let {inputFile} = this.state
        inputFile.current.click();
    };


    render() {
        let {t} = this.props

        let Form_type_ID = this.props.Form_type_ID
        let Form_desc_he = this.props.Form_desc_he
        let FileUrl = this.props.FileUrl?this.props.FileUrl:[]
        let File_Name = this.props.File_Name?this.props.File_Name:[]

        let multipleFiles = FileUrl.map( (item,index)=> {
            return (
                    <div className={'uploaded-files-view-Block'}>
                        <SvGraphics className={'uploaded-files-label-button-Leumit'}
                                    svgname={'pdf-svg'}/>
                        <label className={'uploaded-files-name'}> {File_Name[index]} </label>
                        <a href={item} target="_blank" className={'uploaded-files-label-view-Leumit'}> {t('patient_self_boarding.see_file')}</a>

                        <SvGraphics className={'uploaded-files-label-button-Leumit'}
                                    onClick={() => this.deleteUploadedFile(index,File_Name[index])} svgname={'delete-icon'}/>
                    </div>

              )
        })

        return (
            <div>
                <div className={'patientsFormRow'} id={'uploadFile'}>
                    <div className={'fileForms-label-Leumit'}>{Form_desc_he}*</div>

                    {!this.state.isUploadingMultipleFile &&

                    <Files
                        className='UploadFiles-responsive'
                        onChange={this.onFilesChange}
                        maxFiles={20}
                        maxFileSize={1000000000}
                        minFileSize={0}
                        clickable>
                        <div className={"UploadFiles-div-label"}>

                            <SvGraphics className={"uploadFiles-icon"} svgname={'plus-svg'} width={'12px'} height={'12px'}/>
                            <label className={"uploadFiles-text"}>
                                {t('patient_self_boarding.choose_file')}
                            </label>

                        </div>


                    </Files>

                    }

                    {this.state.isUploadingMultipleFile && <div className="loader-uploadfiles"/>}


                </div>

                {multipleFiles}
            </div>

        )
    }
}

LeumitSelfUpdateFileResponsiveComponent.propTypes = {
    onValueChange: PropTypes.func.isRequired,
    saveSelectedFile: PropTypes.func.isRequired,
    entry: PropTypes.object.isRequired,
    isDisabled: PropTypes.bool
}

export default LeumitSelfUpdateFileResponsiveComponent;
